let subContracts = () => import('../app/Components/Views/SubContracts/SubContractDetails.vue'); // <- ruta donde estan los tabs

export default [
   { path: '/sub_contracts', component: subContracts, name: 'sub-contracts-detail' }
]